module.exports = __webpack_public_path__ + "img/DNADamage-PRCA_10X_AIC.79a948e5.png";